import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";

const SessionsCarousel = ({
  selectedSession,
  setSelectedSession,
  sessionsData,
}) => {
  const scrollContainerRef = useRef(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);
  const [scrollable, setScrollable] = useState(false); // new state to detect overflow

  // Scroll function
  const scroll = (direction) => {
    const container = scrollContainerRef.current;
    const scrollAmount = 300;
    if (!container) return;
    if (direction === "left") container.scrollLeft -= scrollAmount;
    else container.scrollLeft += scrollAmount;
  };

  // Update arrow visibility
  const handleScroll = () => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const isAtStart = container.scrollLeft <= 0;
    const isAtEnd =
      container.scrollLeft + container.clientWidth >= container.scrollWidth - 5;

    setAtStart(isAtStart);
    setAtEnd(isAtEnd);
  };

  // Check if container is scrollable
  const checkScrollable = () => {
    const container = scrollContainerRef.current;
    if (!container) return;
    const isScrollable = container.scrollWidth > container.clientWidth;
    setScrollable(isScrollable);
    handleScroll();
  };

  // Attach listeners
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    container.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", checkScrollable);

    checkScrollable(); // initial check

    return () => {
      container.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", checkScrollable);
    };
  }, []);

  return (
    <div className="position-relative">
      {/* Left arrow — shown only if scrollable */}
      {scrollable && (
        <Button
          className="btn btn-light shadow-sm position-absolute d-flex align-items-center justify-content-center"
          style={{
            top: "30%",
            left: "-15px",
            zIndex: 5,
            borderRadius: "50%",
            width: "30px",
            height: "30px",
            color: "#fff",
            backgroundColor: "#007bffdb",
            opacity: atStart ? 0.5 : 1,
            cursor: atStart ? "not-allowed" : "pointer",
          }}
          onClick={() => scroll("left")}
          disabled={atStart}
        >
          <i className="pi pi-angle-left"></i>
        </Button>
      )}

      {/* Scrollable Container */}
      <div
        ref={scrollContainerRef}
        className="d-flex overflow-auto pb-3"
        style={{
          scrollBehavior: "smooth",
          gap: "0.5rem",
          whiteSpace: "nowrap",
          backgroundColor: "transparent",
        }}
      >
        {sessionsData?.map((s, i) => (
          <div
            key={i}
            className={`card scroll-card text-center flex-shrink-0 ${
              selectedSession === i ? "active" : ""
            }`}
            style={{
              width: "215px",
              height: "120px",
              border: "2px solid #999",
              cursor: "pointer",
              borderRadius: "0",
              opacity: selectedSession === i ? 1 : 0.6,
            }}
            onClick={() => setSelectedSession(i)}
          >
            <div className="card-body p-0">
              <div
                className="position-relative"
                style={{
                  backgroundColor: "#f8f9fa",
                  height: "81px",
                }}
              >
                {/* Play icon overlay */}
                <i
                  className="pi pi-play-circle"
                  style={{
                    fontSize: "2.5rem",
                    color: "#007bff",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                ></i>
              </div>
              <div className="mt-2 text-truncate">
                <strong>{s.name}</strong> – {s.title}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Right arrow — shown only if scrollable */}
      {scrollable && (
        <Button
          className="btn btn-light shadow-sm position-absolute d-flex align-items-center justify-content-center"
          style={{
            top: "30%",
            right: "-15px",
            zIndex: 5,
            borderRadius: "50%",
            width: "30px",
            height: "30px",
            color: "#fff",
            backgroundColor: "#007bffdb",
            opacity: atEnd ? 0.5 : 1,
            cursor: atEnd ? "not-allowed" : "pointer",
          }}
          onClick={() => scroll("right")}
          disabled={atEnd}
        >
          <i className="pi pi-angle-right"></i>
        </Button>
      )}
    </div>
  );
};

export default SessionsCarousel;
